import { useEffect } from 'react';

const useAssessmentPortalStepTitle = (stepLabel: string | undefined) => {
  useEffect(() => {
    if (!stepLabel) return;
    document.title = stepLabel;
  }, [stepLabel]);
};

export default useAssessmentPortalStepTitle;
